import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Defines the public route map for the conference site.
import { Navigate, Route, Routes } from "react-router-dom";
import { Landing } from "../pages/Landing";
import { SchedulePage } from "../pages/Schedule/Schedule";
import { SpeakersPage } from "../pages/Speakers/Speakers";
import { MediaPage } from "../pages/Media/Media";
import { FAQPage } from "../pages/FAQ/FAQ";
import { RegistrationPage } from "../pages/Registration/Registration";
import { showConferencePages } from "../config/featureFlags";
export function AppRoutes() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Landing, {}) }), showConferencePages && (_jsxs(_Fragment, { children: [_jsx(Route, { path: "/schedule", element: _jsx(SchedulePage, {}) }), _jsx(Route, { path: "/speakers", element: _jsx(SpeakersPage, {}) }), _jsx(Route, { path: "/faq", element: _jsx(FAQPage, {}) }), _jsx(Route, { path: "/register", element: _jsx(RegistrationPage, {}) })] })), _jsx(Route, { path: "/media", element: _jsx(MediaPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }));
}
